import { render, staticRenderFns } from "./LearningSuitcaseTeacherView.vue?vue&type=template&id=28397146&scoped=true"
import script from "./LearningSuitcaseTeacherView.vue?vue&type=script&lang=js"
export * from "./LearningSuitcaseTeacherView.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=28397146&prod&scoped=true&lang=css&external"
import style1 from "./LearningSuitcaseTeacherView.vue?vue&type=style&index=1&id=28397146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28397146",
  null
  
)

export default component.exports